module.exports = __webpack_public_path__ + "files/SPIADI2026 - NÉO INF ADI.a64f3e15bd53debc67edbc68101b5990.xlsx";